import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { OnboardingConfigService } from '@app/onboarding/services/onboarding-config.service';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { FooterButtonStates } from '@app/onboarding/components/onboarding-footer/onboarding-footer.model';
import { OnboardingStep } from '@app/onboarding/onboarding.enums';
import { OnboardingStateService } from '@app/onboarding/services/onboarding-state.service';

/**
 * Get Strated Component
 * The last page the user sees when going thru the onboarding experience
 *
 * There are 3 different onboarding configurations of the welcome screen
 * LXP - does not have a start learning page. Users are redirected to profile builder
 * HMM(Harvard sparks)
 * DSA
 *
 * <dgx-startlearning></dgx-startlearning>
 */
@Component({
  selector: 'dgx-startlearning',
  templateUrl: './startlearning.component.html',
})
export class StartLearningComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  public isLoading: boolean = true;
  public templatePrefix: string = '';

  public i18n = this.translateService.instant([
    'Onboarding_Step1IdeasImgAlt',
    'Onboarding_RatingOverflowImgAlt',
    'Onboarding_RatingOverflowTitle',
    'Onboarding_RatingOverflowInstructions',
    'Onboarding_GetStartedHeader',
    'Onboarding_StartLearningBody',
    'OnboardingFooter_PreviousStep',
    'OnboardingFooter_StartLearning',
  ]);

  constructor(
    private translateService: TranslateService,
    private webEnvironmentService: WebEnvironmentService,
    private onboardingConfigService: OnboardingConfigService,
    private onboardingStateService: OnboardingStateService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.onboardingConfigService.footerButtonStateChange({
      currentStep: OnboardingStep.startLearning,
      previousButton: this.i18n.OnboardingFooter_PreviousStep,
      nextButton: this.i18n.OnboardingFooter_StartLearning,
    } as FooterButtonStates);

    this.onboardingConfigService.config.subscribe((config) => {
      this.isLoading = false;
      this.templatePrefix = config.templatePrefix;
      this.onboardingStateService.updateTrackerStep(
        this.onboardingConfigService.getTrackerSteps(
          this.templatePrefix,
          OnboardingStep.startLearning
        )
      );
    });
  }

  public getBlobUrl(url) {
    return this.webEnvironmentService.getBlobUrl(url);
  }
}
